import { useTheme } from '@mui/material/styles'
import { Box, List, ListItem, ListItemText, Typography } from '@mui/material'
import NumberFunctions from '../../../core/functions/NumberFunctions'
import { TBalanceCurrency } from '../../../core/types/Tenant'

export const BalanceDarkCard = ({
  balance,
  title = 'Saldo disponível',
  currency = 'brl',
}: {
  balance: number
  title?: string | React.ReactNode
  currency?: TBalanceCurrency
}) => {
  const theme = useTheme()

  return (
    <Box
      display="flex"
      width={{ xs: '100%', sm: '50%' }}
      justifyContent="center"
      alignItems="flex-start"
      sx={{ p: 2 }}
    >
      <List sx={{ py: 0 }}>
        <ListItem disableGutters sx={{ py: 0 }}>
          <ListItemText
            sx={{
              py: 0,
              mt: 0.45,
              mb: 0.45,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '8px',
            }}
            primary={
              <Typography
                variant="subtitle2"
                sx={{
                  size: '12px',
                  lineHeight: '16px',
                  alignContent: 'center',
                  color: theme.palette.grey[900],
                  mt: 0.25,
                }}
              >
                {title}
              </Typography>
            }
            secondary={
              <Typography variant="h5" sx={{ color: theme.palette.grey[900] }}>
                {NumberFunctions.formatMoneyDefault(balance, currency)}
              </Typography>
            }
          />
        </ListItem>
      </List>
    </Box>
  )
}
